import {
    TRACK_ANALYTICS4_EVENT,
} from './types'

export function trackGA4Event (event) {
    return {
        type: TRACK_ANALYTICS4_EVENT,
        event,
    }
}
